import { create } from 'zustand';
import { CartValuesServiceStore } from '../shoppingCart/shoppingCartStore';

type State = {
    isVisibleShoppingWave: boolean;
    viewDifficultyLevel: boolean;
    difficultLevelElement: CartValuesServiceStore | null;
};

type Action = {
    setIsVisibleShoppingWave: (shoppingWave: boolean) => void;
    setViewDifficultyLevel: (viewDifficultyLevel: boolean) => void;
    setDifficultLevelElement: (
        difficultLevelElement: CartValuesServiceStore | null
    ) => void;
};

export const useModalShoppingStore = create<State & Action>(set => ({
    isVisibleShoppingWave: false,
    viewDifficultyLevel: true,
    difficultLevelElement: null,

    setDifficultLevelElement: difficultLevelElement => {
        set(() => ({
            difficultLevelElement,
        }));
    },
    setViewDifficultyLevel: viewDifficultyLevel => {
        set(() => ({
            viewDifficultyLevel,
        }));
    },
    setIsVisibleShoppingWave: shoppingWave => {
        set(() => ({
            isVisibleShoppingWave: shoppingWave,
        }));
    },
}));
